import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=0848cd2c"
import script from "./InfoPanel.vue?vue&type=script&lang=js"
export * from "./InfoPanel.vue?vue&type=script&lang=js"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=0848cd2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports